<!-- Header For Form -->
<div class="sub-header" *ngIf="!loading && !isBlockMode">
  <div class="container" style="height: 100%;">
    <div class="controls-panel">
      <h5 class="headerName">District Overview</h5>
    </div>
  </div>
</div>

<!-- Loading bar -->
<app-loader [loading]="loading"></app-loader>

<!-- Map -->
<div class="{{isBlockMode ? '' : 'container'}}">
  <div [hidden]="loading" class="marginTop15">
    <!-- Inputs + Map -->
    <div class="row justify-content-center">
      <div class="col-lg-7 col-md-7 col-sm-12 paddingLeftZero">
        <!-- Address -->
        <div class="d-flex mr-3">
          <label class="pt-0 mr-2">Address: </label>
          <div>{{locationInfo.ADDRESS}}</div>
        </div>
        <div class="d-flex">
          <div class="d-flex mr-3">
            <label class="pt-0 mr-2">Zip: </label>
            <div>{{address.code}}</div>
          </div>
          <div class="d-flex mr-3">
            <label class="pt-0 mr-2">City: </label>
            <div>{{address.city}}</div>
          </div>
          <div class="d-flex">
            <label class="pt-0 mr-2">State: </label>
            <div>{{commonService.getStateName(address.state)}}</div>
          </div>
        </div>

        <!-- Zip, City, State input (Not in use) -->
        <div class="row formAlignment d-none">
          <!-- Zip Code -->
          <div class="col-md-3 form-group paddingLeftZero marginBottomZero">
            <label>Zip</label>
            <div class="d-flex">
              <input type="text" class="form-control" (keypress)="commonService.isNumber($event);" placeholder="ZIP"
                [(ngModel)]="address.code" maxlength="5" (ngModelChange)="getAddressBasedOnZip()" />
              <span class="loading-icon-small loading-icon-margin" *ngIf="showZipLoading"></span>
            </div>
          </div>

          <!-- City -->
          <div class="col-md-3 form-group paddingLeftZero marginBottomZero">
            <label>City</label>
            <input type="text" class="form-control" placeholder="City" [(ngModel)]="address.city" />
          </div>

          <!-- State -->
          <div class="col-md-4 form-group paddingLeftZero marginBottomZero" style="padding-right: 0;">
            <label>State</label>
            <select class="form-control" [(ngModel)]="address.state">
              <option value="">Select State</option>
              <option *ngFor="let state of commonService.states" [ngValue]="state.value">{{state.name}}</option>
            </select>
          </div>

          <!-- Submit Button -->
          <div class="col-md-2 textCenter">
            <button class="btn btn-rbv" (click)="submitAddress(true)" [disabled]="!address.city || !address.state"
              type="submit">Submit</button>
          </div>
        </div>

        <!-- Map view -->
        <div [hidden]="!isShowMap" class="mapPosition">

          <!-- Map -->
          <div class="map-view marginBottom15" id="map-view{{idIndex}}"></div>

          <!-- Canvas -->
          <div>
            <div class="canvas-cont" [hidden]="isCropMode">
              <canvas width="600" height="428" class="mapCanvas" id="mapCanvas{{idIndex}}"></canvas>
            </div>

            <!-- Crop image -->
            <div [hidden]="!isCropMode" class="{{isCropMode ? 'd-inline-block' : '' }}">
              <angular-cropper #angularCropper1 [cropperOptions]="cropConfig" imageUrl="{{mapImage}}"></angular-cropper>
            </div>
          </div>

          <!-- Map toolbar -->
          <div class="mapToolbar">
            <div class="row toolbar-container">
              <!-- Position -->
              <div class="col-4 p-0 section">
                <div class="section-name">Position</div>
                <div class="d-flex flex-wrap">
                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="moveLeft()" title="Move left"><i class="fa fa-arrow-left"></i></button>
                    <div class="hint">Move map to the left</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="moveRight()" title="Move right"><i class="fa fa-arrow-right"></i></button>
                    <div class="hint">Move map to the right</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="zoomIn()" title="Zoom in"><i class="fa fa-plus"></i></button>
                    <div class="hint">Zoom in over the map</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="zoomOut()" title="Zoom out"><i class="fa fa-minus"></i></button>
                    <div class="hint">Zoom out over the map</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="moveTop()" title="Move top"><i class="fa fa-arrow-up"></i></button>
                    <div class="hint">Move map to the top</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="moveDown()" title="Move down"><i class="fa fa-arrow-down"></i></button>
                    <div class="hint">Move map to the down</div>
                  </div>
                </div>
              </div>

              <!-- Draw -->
              <div class="col-4 pl-2 pr-0 section">
                <div class="section-name">Draw</div>
                <div class="d-flex flex-wrap">
                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="canvasService.addTextToCanvas(canvas)" title="Text"><i class="fa fa-font"></i></button>
                    <div class="hint">Add Text on map</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="canvasService.addCircleToCanvas(canvas, shapeBorderColor, shapeStroke, shapeStrokeWidth)" title="Circle"><i class="fa fa-circle-o"></i></button>
                    <div class="hint">Add Circle on map</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction squareIcon" (click)="canvasService.addRectangleToCanvas(canvas, shapeBorderColor, shapeStroke, shapeStrokeWidth)" title="Square"><i class="fa fa-square-o"></i></button>
                    <div class="hint">Add Square on map</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="canvasService.addArrowToCanvas(canvas, shapeStroke, shapeStrokeWidth)" title="Arrow"><i class="fa fa-long-arrow-right rotate225"></i></button>
                    <div class="hint">Add Arrow on map</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="canvasService.fillColor(canvas, shapeFillColor)" title="Apply Color"><i class="fa fa-paint-brush"></i></button>
                    <div class="hint">Fill Shape with Color</div>
                  </div>

                  <div class="hinted relative">
                    <div class="btn-group" dropdown>
                        <button dropdownToggle type="button" class="map-action-button mapAction dropdown-toggle">
                            <hr class="shapeButtonBorder">
                        </button>
                        <ul *dropdownMenu class="borderDropdown dropdown-menu" role="menu">
                            <li role="menuitem" (click)="selectShapeBorderWidth(1)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border1"></div></li>
                            <li role="menuitem" (click)="selectShapeBorderWidth(2)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border2"></div></li>
                            <li role="menuitem" (click)="selectShapeBorderWidth(3)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border3"></div></li>
                            <li role="menuitem" (click)="selectShapeBorderWidth(4)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border4"></div></li>
                            <li role="menuitem" (click)="selectShapeBorderWidth(5)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border5"></div></li>
                            <li role="menuitem" (click)="selectShapeBorderWidth(6)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border6"></div></li>
                            <li role="menuitem" (click)="selectShapeBorderWidth(7)"><div class="borderDropdownItem dropdown-item"><hr class="shape-border border7"></div></li>
                        </ul>
                    </div>
                    <div class="hint">Select width of border</div>
                  </div>

                  <div class="hinted relative">
                    <input class="color-picker-input" title="Fill Color" [style.background]="shapeFillColor" [(colorPicker)]="shapeFillColor" (colorPickerOpen)="canvasService.changeFillColor('colorPickerOpen', $event, canvas, shapeFillColor)" (colorPickerClose)="canvasService.changeFillColor('colorPickerClose', $event, canvas, shapeFillColor)" (cpInputChange)="canvasService.changeFillColor('cpInputChange', $event, canvas, shapeFillColor)" (cpSliderDragStart)="canvasService.changeFillColor('cpSliderDragStart', $event, canvas, shapeFillColor)" (cpSliderDragEnd)="canvasService.changeFillColor('cpSliderDragEnd', $event, canvas, shapeFillColor)" style="margin-right: 5px;"/>
                    <div class="hint">Select background color for drawing item</div>
                  </div>

                  <div class="hinted relative">
                    <input class="color-picker-input" title="Border Color" [style.background]="shapeStroke" [(colorPicker)]="shapeStroke" (colorPickerOpen)="canvasService.changeBorderColor('colorPickerOpen', $event, canvas, shapeStroke)" (colorPickerClose)="canvasService.changeBorderColor('colorPickerClose', $event, canvas, shapeStroke)" (cpInputChange)="canvasService.changeBorderColor('cpInputChange', $event, canvas, shapeStroke)" (cpSliderDragStart)="canvasService.changeBorderColor('cpSliderDragStart', $event, canvas, shapeStroke)" (cpSliderDragEnd)="canvasService.changeBorderColor('cpSliderDragEnd', $event, canvas, shapeStroke)"/>
                    <div class="hint">Select color of border</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="canvasService.removeObject(canvas)" title="Remove"><i class="fa fa-trash"></i></button>
                    <div class="hint">Remove Selected Shape</div>
                  </div>
                </div>
              </div>

              <!-- Edit -->
              <div class="col-4 pl-2 pr-0 section">
                <div class="section-name">Manipulate</div>
                <div class="d-flex flex-wrap">
                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="cropAnImage()" title="Crop"><i class="fa {{isCropMode ? 'fa-check' : 'fa-crop'}}"></i></button>
                    <div class="hint">Apply crop on existing image</div>
                  </div>

                  <div class="hinted relative">
                    <button class="map-action-button mapAction" (click)="changeMapView()" title="Change View"><i class="fa fa-street-view"></i></button>
                    <div class="hint">Change to the street view</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Download Button -->
          <div class="downloadBtn" *ngIf="!isBlockMode">
            <button class="btn btn-rbv" (click)="downloadImage()" type="button">Download Image</button>
          </div>
        </div>
      </div>

      <!-- Search + List + No list message -->
      <div class="col-lg-5 col-md-5 col-sm-12 paddingZero" [hidden]="!isShowMap">
        <!-- Search inputs in a given city -->
        <div class="form-group marginBottom5">
          <label>Search</label>
          <div class="dflex">
            <!-- Search input -->
            <input type="text" class="form-control marginBottom15" placeholder="search" [(ngModel)]="address.searchValue"
              id="place-search{{idIndex}}" />

            <!-- Get additional info Button -->
            <button class="btn btn-rbv marginLeft10" (click)="getPlaceAdditionalInfo()" type="button">Get Info</button>
          </div>
        </div>

        <!-- Places list -->
        <div class="boxBorder" *ngIf="placesList?.length > 0 && !showSearchloading">
          <div *ngFor="let place of placesList; let i=index;" class="placeList {{place.IS_MARKED ? 'opacityHalf' : ''}}"
            (click)="getPlaceDetailAndCreateMarker(i)">

            <!-- Marker Image -->
            <img class="place-icon" *ngIf="place.MARKER_NUMBER && place.IS_MARKED"
              [src]="markerIconURL + place.MARKER_NUMBER" alt="Marker Image"/>

            <!-- Other Details -->
            <div>
              <div class="placeName">
                {{place.PLACE.name}}
                <span class="floatRight" *ngIf="place.RATING >= 0">
                  {{place.RATING}}
                  <i class="fa {{place.RATING >= 1 || place.RATING === 0.8 || place.RATING === 0.9 ? 'fa-star' : place.RATING === 0 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
                  <i class="fa {{place.RATING >= 2 || place.RATING === 1.8 || place.RATING === 1.9 ? 'fa-star' : place.RATING <= 1 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
                  <i class="fa {{place.RATING >= 3 || place.RATING === 2.8 || place.RATING === 2.9 ? 'fa-star' : place.RATING <= 2 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
                  <i class="fa {{place.RATING >= 4 || place.RATING === 3.8 || place.RATING === 3.9 ? 'fa-star' : place.RATING <= 3 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
                  <i class="fa {{place.RATING === 5 || place.RATING === 4.8 || place.RATING === 4.9 ? 'fa-star' : place.RATING <= 4 ? 'fa-star-o' : 'fa-star-half-o'}}"></i>
                </span>
              </div>
              <div class="placeAddress">{{place.PLACE.formatted_address}}</div>
              <div class="placeAddress" *ngIf="place.SHOW_EXTRA_DETAIL">
                <div>Number : {{place.NUMBER}}</div>
                <div>Website : {{place.WEBSITE}}</div>
              </div>
              <div *ngIf="place.SHOW_DETAIL_LOADING" class="textCenter">
                <span class="loading-icon-small"></span>
              </div>
              <div class="addPlaceIcon"><i class="fa {{place.IS_MARKED ? 'fa-minus' : 'fa-plus'}}"></i></div>
            </div>
          </div>
        </div>

        <!-- Loading for place list -->
        <div *ngIf="showSearchloading" class="textCenter">
          <span class="loading-icon-small"></span>
        </div>

        <!-- No places found message -->
        <div *ngIf="placesList?.length === 0 && !showSearchloading" class="noListMessage">
          No places found
        </div>
      </div>
    </div>
  </div>
</div>
